import { PlanLimitConfigs, BillingCycleConfig } from '../types.ts';

export const ROVO_DEV_DEFAULT_BILLING_CYCLE = 'MONTHLY';
export const ROVO_DEV_DEFAULT_UNIT_COUNT = 10;

export const ROVO_DEV_MIN_ENTERPRISE_USER_COUNT = Infinity;

export const rovoDevOfferingSkus = {
	standard: 'rovodev-standard',
} as const;

export const rovoDevOfferingSkusArray = Object.values(rovoDevOfferingSkus);

export const rovoDevPlanLimitConfigs: PlanLimitConfigs[] = [
	{
		planName: 'Standard',
		offeringSku: rovoDevOfferingSkus.standard,
		recommendationLimit: Infinity,
		signupLimit: Infinity,
		minUnitCount: ROVO_DEV_MIN_ENTERPRISE_USER_COUNT,
	},
];

export const rovoDevBillingCycleConfig: BillingCycleConfig = {
	monthly: false,
	annual: false,
};
